const CURRENCY_SYMBOLS: Record<string, string> = {
    EUR: '€',
    USD: '$',
    GBP: '£',
};

export function formatCurrencyDisplay(code?: string): string {
    const normalized = (code || 'EUR').toUpperCase();
    return CURRENCY_SYMBOLS[normalized] || normalized;
}

export function formatCurrencyCode(code?: string): string {
    return (code || 'EUR').toUpperCase();
}
